import { createAction } from '@reduxjs/toolkit';

export const changePassword = createAction<{
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}>('App/UserProfilePage/CHANGE_PASSWORD');

export const changeEmail = createAction<{
  newEmail: string;
}>('App/UserProfilePage/CHANGE_EMAIL');

export const sendFeedback = createAction<{
  subject: string;
  message: string;
}>('App/UserProfilePage/SEND_FEEDBACK');
